import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from '../../shared/services/api.service';
import { UtilService } from '../../shared/services/util.service';
import { AuthService } from '../../shared/services/auth.service';

@Component({
  standalone: false,
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent {

  loginObj = {
    email: '',
    password: ''
  };
  errorMessage = '';
  passwordType = 'password';
  showPassword = false;

  constructor(private _apiService: ApiService,
    private _util: UtilService,
    private _auth: AuthService,
    private router: Router
  ) {

  }

  onLogin(formData: any) {
    const vm = this;
    if (formData.valid) {
      vm._apiService.postData('/users/auth/login', vm.loginObj).subscribe((res: any) => {
        if (res && !res.error) {
          // Token stored in httpOnly cookie by backend (WEB-01)
          // No longer stored in sessionStorage
          
          // Set user data temporarily
          vm._auth.setUser(res.data);
          
          // Check if this is the user's first login
          if (res.data.isFirstLogin === true) {
            // Redirect to change password page (outside MFA guard)
            this.router.navigate(['/reset-password']);
          } else {
            // Check if MFA is enabled for this user
            vm.checkMfaStatus(res.data.email);
          }
        } else {
          vm.errorMessage = res.message;
        }
      });
    }
  }

  checkMfaStatus(email: string): void {
    this._apiService.postData('/users/totp-mfa/status', { email: email }).subscribe((res: any) => {
      if (res && !res.error && res.data.isMfaEnabled) {
        // MFA is enabled, redirect to MFA login
        this.router.navigate(['/mfa-login']);
      } else {
        // MFA is not enabled, mark as verified and proceed to dashboard
        const user = this._auth.getUser();
        if (user) {
          user.mfaVerified = true;
          this._auth.setUser(user);
        }
        this._util.navigate('/app');
      }
    }, (error) => {
      // Fail closed: on error, do not mark as verified or navigate to app
      this.errorMessage = 'Unable to verify MFA status. Please try again.';
    });
  }

  onShowPassword() {
    const vm = this;
    vm.showPassword = !vm.showPassword;
    vm.passwordType = vm.showPassword ? 'text' : 'password';
  }
}
